/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export interface ICheckoutRecycleFeeTaxUpdate {
    recycleFee: number | null;
    tax: number | null;
}
/**
 * GetRecycleFeeCheckout Input Action
 */
export class GetRecycleFeeCheckoutInput implements Msdyn365.IActionInput {

    //   Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `CheckoutUpdateRecycleFee`;
    public getCacheObjectType = () => 'CheckoutUpdateRecycleFee';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

//   Create a data model here or import one to capture the response of the action
/**
 *   Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetRecycleFeeCheckoutInput();
};

/**
 *   Use this function to call your action and process the results as needed
 */
async function action(input: GetRecycleFeeCheckoutInput, ctx: Msdyn365.IActionContext): Promise<ICheckoutRecycleFeeTaxUpdate> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    //   Uncomment the below line to get the value from a service
    return {recycleFee: null , tax: null};
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ICheckoutRecycleFeeTaxUpdate>>action,
    //   Give your data action a unique id
    id: 'GetRecycleFeeCheckout',
    input: createInput
    //   Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
